import { IConfiguratorData } from "Interfaces/interface.mockupGenerator";
import { SparklesIcon } from "lucide-react";
import React from "react";

const SelectionOverlay = React.memo(
  ({
    imageWidth,
    imageHeight,
    selectedConfig,
    naturalWidth,
    naturalHeight,
  }: {
    imageWidth: number;
    imageHeight: number;
    selectedConfig: IConfiguratorData | null | undefined;
    naturalWidth: number;
    naturalHeight: number;
  }) => {
    if (
      !selectedConfig ||
      !imageWidth ||
      !imageHeight ||
      !naturalWidth ||
      !naturalHeight
    ) {
      console.warn("Invalid SelectionOverlay props:", {
        selectedConfig,
        imageWidth,
        imageHeight,
        naturalWidth,
        naturalHeight,
      });
      return null;
    }

    const [x, y] = selectedConfig.coordinates || [0, 0];
    const [width, height] = selectedConfig.dimensions || [100, 100];

    const scaleX = imageWidth / naturalWidth;
    const scaleY = imageHeight / naturalHeight;

    const scaledX = x * scaleX;
    const scaledY = y * scaleY;
    let scaledWidth = width * scaleX;
    let scaledHeight = height * scaleY;

    const minDimension = 20;
    scaledWidth = Math.max(minDimension, scaledWidth);
    scaledHeight = Math.max(minDimension, scaledHeight);

    const boundedX = Math.max(0, Math.min(scaledX, imageWidth - scaledWidth));
    const boundedY = Math.max(0, Math.min(scaledY, imageHeight - scaledHeight));

    if (scaledWidth <= 0 || scaledHeight <= 0) {
      console.warn("Invalid scaled dimensions:", { scaledWidth, scaledHeight });
      return null;
    }

    const showText = scaledWidth > 60 && scaledHeight > 45;
    const showIcon = scaledWidth > 30 && scaledHeight > 30;

    return (
      <div
        className="absolute border-2 border-indigo-500 rounded-lg shadow-md pointer-events-none bg-indigo-100/20 animate-pulse-border overflow-hidden"
        style={{
          left: `${boundedX}px`,
          top: `${boundedY}px`,
          width: `${scaledWidth}px`,
          height: `${scaledHeight}px`,
          transition: "all 0.3s ease",
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center p-1">
          <div className="text-center text-indigo-600 flex flex-col items-center justify-center min-w-0 min-h-0">
            {showIcon && (
              <SparklesIcon
                className={`${showText ? "w-4 h-4 mb-1" : "w-5 h-5"
                  } mx-auto opacity-60 flex-shrink-0`}
              />
            )}
            {showText && (
              <p className="text-[10px] sm:text-xs font-medium tracking-tight truncate w-full">
                Logo Area
              </p>
            )}
          </div>
        </div>
        <div className="absolute w-2 h-2 bg-indigo-500 rounded-full -right-1 -bottom-1"></div>
        <div className="absolute w-2 h-2 bg-indigo-500 rounded-full -left-1 -bottom-1"></div>
        <div className="absolute w-2 h-2 bg-indigo-500 rounded-full -right-1 -top-1"></div>
        <div className="absolute w-2 h-2 bg-indigo-500 rounded-full -left-1 -top-1"></div>
      </div>
    );
  }
);

export default SelectionOverlay;